'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuPopoverClassNames: function() {
        return menuPopoverClassNames;
    },
    useMenuPopoverStyles_unstable: function() {
        return useMenuPopoverStyles_unstable;
    }
});
const _react = require("@griffel/react");
const menuPopoverClassNames = {
    root: 'fui-MenuPopover'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        De3pzq: "fxugw4r",
        sj55zd: "f19n0e5",
        B7ck84d: "f1ewtqcl",
        Bf4jedk: "fl8fusi",
        B2u0y6b: "f1kaai3v",
        B68tc82: "f1p9o1ba",
        a9b677: "f1ahpp82",
        E5pizo: "f1hg901r",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fd3pd8h",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f9ggezi",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        B93otf3: "f18k4bn6",
        vin17d: "fo1kyvf",
        Ezkn3b: "fetxo7e",
        nyiy2g: "f8x1vz1",
        swvrvq: "f8g0anz",
        Bkovbt3: "fezwn9i",
        hgjdhn: "fz5efge",
        fsy9dk: "f1ydixl4",
        B3ogreh: "f8dgqj5",
        jv49x5: "fnyfnr8",
        Bk7o48c: "fgw77r4",
        Bv12yb3: "f1noc5he",
        i09l9u: "f1k46bua",
        Bcrj8ia: "f1lhuzxm",
        Bmmhre5: "f1f9qikc"
    }
}, {
    d: [
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".fl8fusi{min-width:138px;}",
        ".f1kaai3v{max-width:300px;}",
        ".f1p9o1ba{overflow-x:hidden;}",
        ".f1ahpp82{width:max-content;}",
        ".f1hg901r{box-shadow:var(--shadow16);}",
        [
            ".fd3pd8h{padding:4px;}",
            {
                p: -1
            }
        ],
        [
            ".f9ggezi{border:1px solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".f18k4bn6{animation-composition:accumulate;}",
        ".fo1kyvf{animation-duration:var(--durationSlower);}",
        ".fetxo7e{animation-timing-function:var(--curveDecelerateMid);}",
        ".f8x1vz1{--fui-positioning-slide-distance-x:0px;}",
        ".f8g0anz{--fui-positioning-slide-distance-y:10px;}",
        ".fezwn9i[data-popper-placement^=right]{--fui-positioning-slide-distance-x:-10px;}",
        ".fz5efge[data-popper-placement^=right]{--fui-positioning-slide-distance-y:0px;}",
        ".f1ydixl4[data-popper-placement^=bottom]{--fui-positioning-slide-distance-x:0px;}",
        ".f8dgqj5[data-popper-placement^=bottom]{--fui-positioning-slide-distance-y:-10px;}",
        ".fnyfnr8[data-popper-placement^=left]{--fui-positioning-slide-distance-x:10px;}",
        ".fgw77r4[data-popper-placement^=left]{--fui-positioning-slide-distance-y:0px;}",
        ".f1noc5he{animation-name:f1m0q9mo,f79suad;}"
    ],
    k: [
        "@keyframes f1m0q9mo{from{opacity:-1;}to{opacity:0;}}",
        "@keyframes f79suad{from{transform:translate(var(--fui-positioning-slide-distance-x), var(--fui-positioning-slide-distance-y));}}"
    ],
    m: [
        [
            "@media (prefers-reduced-motion){.f1k46bua[data-popper-placement]{animation-duration:1ms;}}",
            {
                m: "(prefers-reduced-motion)"
            }
        ],
        [
            "@media (prefers-reduced-motion){.f1lhuzxm[data-popper-placement]{animation-name:f1m0q9mo;}}",
            {
                m: "(prefers-reduced-motion)"
            }
        ]
    ],
    t: [
        "@supports not (animation-composition: accumulate){.f1f9qikc[data-popper-placement]{animation-name:f1m0q9mo;}}"
    ]
});
const useMenuPopoverStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuPopoverClassNames.root, styles.root, state.root.className);
    return state;
};
